import { TriangleAlert } from "lucide-react"

export function AiWarningBanner(): React.JSX.Element {
  return (
    <div className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200">
      <TriangleAlert className="h-3.5 w-3.5 shrink-0" />
      <p>
        <span className="font-semibold">AI-generated content.</span>
        This report was produced by an AI assistant. Always verify information
        from authoritative sources before relying on it.
      </p>
    </div>
  )
}
